module.exports = __webpack_public_path__ + "img/120.6987b080.webp";